import classNames from 'classnames';

import styles from './figcaption.module.scss';
import { FigcaptionProps } from './types';

export function figcaption(props: FigcaptionProps) {
  return (
    <figcaption className={classNames(props.className, styles.figcaption)}>
      {props.children}
    </figcaption>
  );
}
